export default "__VITE_ASSET__Bpilf3ny__"